module.exports = __webpack_public_path__ + "img/dd-video-cover.7571152e.jpg";